"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import AppImage from "@/components/ui/AppImage";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Header() {
  const pathname = usePathname();
  const [scrolled, setScrolled] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Apply RTL to document when Arabic is selected
  useEffect(() => {
    if (language === 'AR') {
      document.documentElement?.setAttribute('dir', 'rtl');
      document.documentElement?.setAttribute('lang', 'ar');
    } else {
      document.documentElement?.setAttribute('dir', 'ltr');
      document.documentElement?.setAttribute('lang', 'en');
    }
  }, [language]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? "bg-cream/98 backdrop-blur-xl shadow-soft-lg border-b border-warm"
            : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-8 md:px-12 h-24 flex items-center justify-between">
          {/* Logo */}
          <Link href="/homepage" className="flex items-center group">
            <AppImage
              src="/assets/images/ChatGPT_Image_21._Feb._2026_11_41_01-1771661568738.png"
              alt="HÅR Extension Logo"
              width={800}
              height={400}
              className="h-16 w-auto object-contain group-hover:opacity-80 transition-opacity duration-300"
            />
          </Link>

          {/* Right Actions */}
          <div className="flex items-center gap-4">
            {/* Language Switcher */}
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-2 text-xs font-semibold tracking-wider text-muted hover:text-gold transition-colors border-2 border-warm rounded-full px-4 py-2 hover:border-gold"
              aria-label="Switch language"
            >
              <span>{language === "EN" ? "AR" : "EN"}</span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
}